module.exports = __webpack_public_path__ + "img/img_promotion_bnr_main_hello.82dfbee6.png";